export const mergeHeaders = (...headersList) => {
    const merged = new Headers();
    for (const headers of headersList) {
        if (!headers)
            continue;
        new Headers(headers).forEach((value, key) => {
            merged.set(key, value);
        });
    }
    return merged;
};
export const setAuthorizationHeader = (headers, token) => {
    if (token) {
        headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
};
